import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const glCodesAdapter = getAdapter();

const glCodesSlice = createSlice({
  name: 'glCodes',
  initialState: glCodesAdapter.getInitialState(),
  reducers: {
    setGlCodes: (state, { payload: { glCodes } }) => {
      glCodesAdapter.setAll(state, glCodes);
    },
  },
});

const selectors = glCodesAdapter.getSelectors(({ glCodes }) => glCodes);
export const getGlCodes = (state) => selectors.selectAll(state);

export const {
  setGlCodes,
} = glCodesSlice.actions;

export default glCodesSlice.reducer;